class MedicalItemOrder {
    public EMRTemplateId: string;
    public EnumMedicalItemSubType: number;
    public SortIndex: number;
}

export { MedicalItemOrder };
